export default __webpack_public_path__ + "static/media/chat-bubble-16.8556b759.svg";